import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/LandingPages'

export const LANDING_PAGES_REQUEST_ASYNC = createAsyncTypes('LANDING_PAGES_REQUEST', typeKey)
export const DELETE_LANDING_PAGE_ASYNC = createAsyncTypes('DELETE_LANDING_PAGE_ASYNC', typeKey)
export const COPY_LANDING_PAGE_ASYNC = createAsyncTypes('COPY_LANDING_PAGE_ASYNC', typeKey)

export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`
